<template>
  <div style="padding-top: 4rem; padding-bottom: 4rem">
    <divider-component />
    <p
      align="center"
      v-if="oferta"
      style="
        font-family: Arial, Helvetica, sans-serif;
        font-size: 2.5rem;
        font-weight: 800;
        color: #1c3e8e;
      "
    >
      {{ oferta.descripcion }}
      <span style="color: red">- {{ oferta.descuento }}%</span>
    </p>
    <divider-component />
  </div>
  <div align="center" v-if="loading">
    <v-progress-circular
      :size="70"
      :width="7"
      color="purple"
      :indeterminate="loading"
    ></v-progress-circular>
  </div>
  <v-container>
    <p>{{ categoria }}</p>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-for="(Itemdata, index) in ProductosOferta"
        :key="index"
      >
        <card-oferta-component
          :Itemdata="Itemdata"
          :descuento="oferta.descuento"
        />
      </v-col>
    </v-row>
  </v-container>
  <div v-if="ProductosOferta.length <= 0">
    <v-card style="margin: 30px">
      <h4 align="center">Por el momento no hay ofertas</h4>
      <v-img alt="" :src="require('@/assets/sin-info.png')" height="100" />
    </v-card>
  </div>
</template>

<script>
import ApiOfertas from '@/Api/ApiOfertas';
import CardOfertaComponent from '@/components/CardOfertaComponent.vue';
import DividerComponent from '@/components/DividerComponent.vue';
export default {
  props: ['ofertaJson'],

  data() {
    return {
      ProductosOferta: [],
      oferta: null,
      loading: true,
    };
  },
  mounted() {
    const ofertaJson = this.$route.query.oferta;
    // Convierte la cadena JSON de nuevo en un objeto
    this.oferta = JSON.parse(ofertaJson);
    this.GetAllProducts();
    this.startPolling();
  },

  components: {
    CardOfertaComponent,
    DividerComponent,
  },
  methods: {
    async GetAllProducts() {
      await ApiOfertas.GetProductsByOferta(this.oferta.descripcion)
        .then((response) => {
          this.ProductosOferta = response.data;
          this.loading = false;
        })
        .catch((error) => {
            this.loading=false;
        });
    },
    startPolling() {
      setInterval(() => {
        this.GetAllProducts();
      }, 5000); // 5000 milisegundos = 5 segundos
    },
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
};
</script>

<style></style>
